
import { Question } from '../types';

export const taj101AdditionalQuestions: Question[] = [
  {
    id: 'taj121',
    text: 'How many makharij (articulation points) are there according to Sībawayh?',
    type: 'single',
    options: [
      { id: 'a', text: '16 makharij', isCorrect: true },
      { id: 'b', text: '17 makharij', isCorrect: false },
      { id: 'c', text: '14 makharij', isCorrect: false },
      { id: 'd', text: '18 makharij', isCorrect: false }
    ],
    explanation: 'According to Sībawayh, there are 16 makharij (articulation points). This differs from the view of Khalīl Ibn Aḥmad al-Farāhīdī, who identified 17 makharij, which is the view held by Ibn al-Jazarī and most contemporary scholars.',
    topic: 'taj101'
  },
  {
    id: 'taj122',
    text: 'What is the difference between tartīl and tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'Tartīl is the practical application of tajweed with proper pace and reflection', isCorrect: true },
      { id: 'b', text: 'Tajweed is limited to the rules of elongation while tartīl covers all pronunciation', isCorrect: false },
      { id: 'c', text: 'Tartīl is only about the speed of recitation, while tajweed is about correct pronunciation', isCorrect: false },
      { id: 'd', text: 'They are synonyms with no difference in meaning', isCorrect: false }
    ],
    explanation: 'Tartīl is the practical application of tajweed rules with proper pace and reflection on the meanings. Tajweed refers to the rules governing proper pronunciation, while tartīl encompasses both applying those rules and reciting at a measured pace with contemplation.',
    topic: 'taj101'
  },
  {
    id: 'taj123',
    text: 'What is the ruling (ḥukm) on learning the rules of tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'Farḍ kifāyah (communal obligation)', isCorrect: true },
      { id: 'b', text: 'Farḍ ʿayn (individual obligation)', isCorrect: false },
      { id: 'c', text: 'Sunnah (recommended)', isCorrect: false },
      { id: 'd', text: 'Mustaḥabb (preferred)', isCorrect: false }
    ],
    explanation: 'Learning the rules of tajweed is farḍ kifāyah (communal obligation), meaning if some members of the community learn it, the obligation is lifted from the rest. However, reciting the Qur\'ān with tajweed is farḍ ʿayn (individual obligation) for every Muslim.',
    topic: 'taj101'
  },
  {
    id: 'taj124',
    text: 'What is the ruling (ḥukm) on reciting the Qur\'ān with tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'Farḍ ʿayn (individual obligation)', isCorrect: true },
      { id: 'b', text: 'Farḍ kifāyah (communal obligation)', isCorrect: false },
      { id: 'c', text: 'Sunnah (recommended)', isCorrect: false },
      { id: 'd', text: 'Mustaḥabb (preferred)', isCorrect: false }
    ],
    explanation: 'Reciting the Qur\'ān with tajweed is farḍ ʿayn (individual obligation) for every Muslim who recites the Qur\'ān. This means every Muslim must strive to apply the basic rules of tajweed when reciting, even if they don\'t know all the technical details.',
    topic: 'taj101'
  },
  {
    id: 'taj125',
    text: 'What is the ruling on making laḥn jaliyy (clear errors) in recitation?',
    type: 'single',
    options: [
      { id: 'a', text: 'Ḥarām (prohibited) if done deliberately without trying to correct it', isCorrect: true },
      { id: 'b', text: 'Makrūh (disliked) but not sinful', isCorrect: false },
      { id: 'c', text: 'Mubāḥ (permissible) for beginners', isCorrect: false },
      { id: 'd', text: 'Farḍ (obligatory) to avoid for scholars only', isCorrect: false }
    ],
    explanation: 'Making laḥn jaliyy (clear errors) in recitation is ḥarām (prohibited) if the reciter is aware of the error and makes no effort to correct it. These errors change the meaning or structure of the Qur\'ānic text and must be avoided.',
    topic: 'taj101'
  },
  {
    id: 'taj126',
    text: 'What is the basis for the science of tajweed in Islamic tradition?',
    type: 'single',
    options: [
      { id: 'a', text: 'The Qur\'ānic command: "And recite the Qur\'ān with tartīl"', isCorrect: true },
      { id: 'b', text: 'The consensus of modern scholars', isCorrect: false },
      { id: 'c', text: 'Regional recitation styles', isCorrect: false },
      { id: 'd', text: 'Personal preference for beautiful recitation', isCorrect: false }
    ],
    explanation: 'The basis for the science of tajweed is found in the Qur\'ānic command in Sūrah al-Muzzammil (73:4): "Wa rattil al-Qur\'āna tartīlā" ("And recite the Qur\'ān with tartīl"). ʿAlī  explained that tartīl means "Excellence in the recitation of the letters and knowledge of waqf."',
    topic: 'taj101'
  },
  {
    id: 'taj127',
    text: 'What are the four ways in which laḥn jaliyy (clear error) can occur?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Adding a letter that doesn\'t exist in the text', isCorrect: true },
      { id: 'b', text: 'Omitting a letter that exists in the text', isCorrect: true },
      { id: 'c', text: 'Changing a letter to another letter', isCorrect: true },
      { id: 'd', text: 'Changing a vowel (ḥarakah)', isCorrect: true }
    ],
    explanation: 'Laḥn jaliyy (clear error) can occur in four ways: 1) Adding a letter that doesn\'t exist in the text, 2) Omitting a letter that exists in the text, 3) Changing a letter to another letter, and 4) Changing a vowel (ḥarakah).',
    topic: 'taj101'
  },
  {
    id: 'taj128',
    text: 'In the context of tajweed, what does waṣl mean?',
    type: 'single',
    options: [
      { id: 'a', text: 'To join or continue recitation without stopping', isCorrect: true },
      { id: 'b', text: 'To stop at the end of a verse', isCorrect: false },
      { id: 'c', text: 'To pause briefly without taking a breath', isCorrect: false },
      { id: 'd', text: 'To elongate a letter', isCorrect: false }
    ],
    explanation: 'In tajweed, waṣl (وَصْل) means to join or continue recitation without stopping. It is the opposite of waqf, which means to stop. Many tajweed rules apply differently depending on whether one is in a state of waṣl or waqf.',
    topic: 'taj101'
  },
  {
    id: 'taj129',
    text: 'What is meant by the term "ṣifāt mutaḍāddah" in tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'Characteristics of letters that have opposites', isCorrect: true },
      { id: 'b', text: 'Characteristics that can be combined in one letter', isCorrect: false },
      { id: 'c', text: 'Characteristics that only apply during waqf', isCorrect: false },
      { id: 'd', text: 'Characteristics that are optional in recitation', isCorrect: false }
    ],
    explanation: 'Ṣifāt mutaḍāddah (صِفَات مُتَضَادَّة) refers to characteristics of letters that have opposites, such as jahr (loudness) vs. hams (whisper), or shiddah (strength) vs. rakhāwah (softness). Due to them being opposites, it is impossible for a letter to have both qualities of a mutaḍāddah pair.',
    topic: 'taj101'
  },
  {
    id: 'taj130',
    text: 'What is the relationship between Ibn al-Jazarī and the science of tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'He was a major scholar who systematized and preserved the science of tajweed', isCorrect: true },
      { id: 'b', text: 'He was the first to invent the rules of tajweed', isCorrect: false },
      { id: 'c', text: 'He rejected most traditional tajweed rules', isCorrect: false },
      { id: 'd', text: 'He had no significant contribution to tajweed', isCorrect: false }
    ],
    explanation: 'Ibn al-Jazarī (Muhammad ibn Muhammad ibn Muhammad ibn Ali ibn Yusuf al-Jazari, d. 833 AH/1429 CE) was one of the most important scholars in the field of Qur\'ānic sciences. He systematized and preserved the science of tajweed and qirā\'āt (recitations) through his works, including "An-Nashr fi al-Qirā\'āt al-ʿAshr" and his famous poem on tajweed, "Al-Jazariyyah".',
    topic: 'taj101'
  }
];
